import React, { useState } from 'react';

import 'react-toastify/dist/ReactToastify.css';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { get } from 'lodash';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';

import { displayErrors } from '../../../../util/diversos';
import { Input200px } from '../../../../styles/inputGroup';

import store from '../../../../store/store';
import Card from '../../../../components/card';
import axiosAdmin from '../../../../services/axiosAdmin';
import Loading from '../../../loading';

export default function CadastroInutilizacao({ payloadCadastro, childToParentConsulta }) {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const cnpjEmpresa = get(payloadCadastro, 'cnpjEmpresa', '');

  const [ano, setAno] = useState('');
  const [mesAnoReferencia, setMesAnoReferencia] = useState(null);
  const [modelo, setModelo] = useState('');
  const [serie, setSerie] = useState('');
  const [numeroInicial, setNumeroInicial] = useState('');
  const [numeroFinal, setNumeroFinal] = useState('');
  const [motivo, setMotivo] = useState('');

  async function salvarRegistro() {
    try {
      setIsLoading(true);

      const idUsuario = get(store.getState().auth.user, 'id', 0);

      const params = `/nfeutil/inutilizarnumeracao?idUsuario=${idUsuario}&cnpjEmpresa=${cnpjEmpresa}&ano=${ano}&mesAnoReferencia=${mesAnoReferencia.replace('/', '')}&modelo=${modelo}&serie=${serie}&numeroInicial=${numeroInicial}&numeroFinal=${numeroFinal}&motivo=${motivo}`;

      await axiosAdmin.get(params);

      toast.success('Inutilização realizada com sucesso');
      childToParentConsulta([]);
    } catch (err) {
      displayErrors(err, dispatch, navigate, '', 'Não foi possível inutilizar numeração');
    } finally {
      setIsLoading(false);
    }
  }

  const handleCancel = () => {
    navigate('/home');
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (Number(ano) <= 0 || ano === null || !Number(ano)) {
      toast.info('Ano inválido');
      return;
    }

    const data = mesAnoReferencia.split('/');
    const mesReferencia = data[0];
    const anoReferencia = data[1];
    if (Number(mesReferencia) <= 0 || Number(mesReferencia) > 12) {
      toast.info('Mês Referência inválido');
      return;
    }
    if (Number(anoReferencia) <= 0 || Number(anoReferencia) > 2099) {
      toast.info('Ano Referência inválido');
      return;
    }
    if (mesAnoReferencia === null) {
      toast.info('Mês/Ano deve ser informado');
      return;
    }

    if (!modelo) {
      toast.info('Modelo deve ser informado');
      return;
    }

    if (!serie) {
      toast.info('Série deve ser informada.');
      return;
    }

    if (!numeroInicial || numeroInicial <= 0 || !Number(numeroInicial)) {
      toast.info('Número Inicial inválido ou não informado.');
      return;
    }

    if (!numeroFinal || numeroFinal <= 0 || !Number(numeroFinal)) {
      toast.info('Número Final inválido ou não informado.');
      return;
    }

    if (parseFloat(numeroInicial) > parseFloat(numeroFinal)) {
      toast.info('Número Inicial maior que Número Final.');
      return;
    }

    if (!motivo || motivo.length < 15) {
      toast.info('Motivo da inutilização deve conter 15 caracteres ou mais.');
      return;
    }

    salvarRegistro();
  };

  return (
    <div>
      <Loading isLoading={isLoading} />
      <Card>
        <div className="card mb-3">
          <h6 className="card-header" style={{ textAlign: 'center' }}>Inutilização de NF-e/NFC-e do Cnpj {cnpjEmpresa}</h6>
        </div>
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Ano
              </Input200px>
              <InputText
                maxLength={2}
                value={ano}
                onChange={e => setAno(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Mês/Ano Referência
              </Input200px>
              <InputMask
                value={mesAnoReferencia}
                onChange={(e) => setMesAnoReferencia(e.target.value)}
                mask="99/9999"
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Modelo
              </Input200px>
              <InputText
                maxLength={3}
                value={modelo}
                onChange={e => setModelo(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Série
              </Input200px>
              <InputText
                title="Série deve ser informada sem zeros a esquerda"
                maxLength={3}
                value={serie}
                onChange={e => setSerie(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Número Inicial
              </Input200px>
              <InputText
                maxLength={9}
                value={numeroInicial}
                onChange={e => setNumeroInicial(e.target.value)}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Número Final
              </Input200px>
              <InputText
                maxLength={9}
                value={numeroFinal}
                onChange={e => setNumeroFinal(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row form-elo">
          <div className="col-12">
            <div className="p-inputgroup">
              <Input200px className="p-inputgroup-addon">
                Motivo
              </Input200px>
              <InputText
                maxLength={150}
                value={motivo}
                onChange={e => setMotivo(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <button
              onClick={handleSubmit}
              type="button"
              className="btn btn-success"
            >
              <i className="pi pi-check"></i>
              Inutilizar
            </button>
            <button
              onClick={handleCancel}
              type="button"
              className="btn btn-danger"
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Card>
    </div>
  );
}
